<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
    <g transform="translate(1 1)" fill="none" stroke="#3498db" stroke-width="1.5">
      <circle cx="7" cy="7" r="7"/>
      <path d="M7 3.999v4.14l2.074 1.24" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  </svg>
</template>
